import { render, staticRenderFns } from "./LoginCardReset.vue?vue&type=template&id=9494c554&scoped=true"
import script from "./LoginCardReset.vue?vue&type=script&lang=ts"
export * from "./LoginCardReset.vue?vue&type=script&lang=ts"
import style0 from "./LoginCardReset.vue?vue&type=style&index=0&id=9494c554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9494c554",
  null
  
)

export default component.exports